module.exports = __webpack_public_path__ + "img/skill-3.65948a32.png";